import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ResponseApi } from "../features/common/interface/responseApi";

@Injectable()
export class ProdutorRuralService {

  private apiUrl = environment.API_URL;

  constructor(private http: HttpClient) {

  }

  getDadosProdutorRural(codigo: string): Observable<any> {
    return this.http.get(
      `${this.apiUrl}/contribuinte/produtorRural/id/${codigo}`
    );
  }

  regularizarProdutorRural(obj: any): Observable<any> {
    return this.http.put(
      `${this.apiUrl}/contribuinte/produtorRural/`, obj
    );
  }

  getSolicitacaoGeral(): Observable<any> {
    return this.http.get(
      `${this.apiUrl}/contribuinte/solicitacao/tiposSolicitacaoGeral`
    );
  }

  getListaSituacao(): Observable<any> {
    return this.http.get(
      `${this.apiUrl}/contribuinte/solicitacao/movimentacao/tiposDeMovimentacao`
    );
  }

  getOrigemBic() {
    return this.http.get(
      `${this.apiUrl}/contribuinte/solicitacao/origemBic`
    );
  }

  getDetalhesMovimentacao(codigo): Observable<any> {
    return this.http.get(
      `${this.apiUrl}/contribuinte/solicitacao/movimentacao/id/${codigo}`
    );
  }

  getArquivos(path): Observable<any> {
    return this.http.post<ResponseApi>(`${this.apiUrl}/caixa-postal/obterAnexo`, path);
  }

  getValidacaoCar(codigoImovel) {
    return this.http.get(
      `${this.apiUrl}/contribuinte/produtorRural/obterCar/${codigoImovel}`
    )
  }
  
  getListaComplementos() {
    return this.http.get(
      `${this.apiUrl}/contribuinte/produtorRural/listarTipoComplementoEndereco`
    )
  }

  getListaClassificacao() {
    return this.http.get(
      `${this.apiUrl}/contribuinte/produtorRural/listarClassificacaoContribuinte`
    )
  }

  getListaRegimeRecolhimento() {
    return this.http.get(
      `${this.apiUrl}/contribuinte/produtorRural/listarTipoRegimeRecolhimento`
    )
  }

  getListaNaturezaJuridica() {
    return this.http.get(
      `${this.apiUrl}/contribuinte/produtorRural/listarNaturezaJuridica`
    )
  }

  getListaCnae(params?) {
    return this.http.get(
      `${this.apiUrl}/contribuinte/produtorRural/listarCnae`,
      { params: params }
    )
  }

  getListaOcupacao() {
    return this.http.get(
      `${this.apiUrl}/contribuinte/produtorRural/listarTipoUsoImovel`
    )
  }

  getListaPaises() {
    return this.http.get(
      `${this.apiUrl}/contribuinte/produtorRural/listarPaises`
    )
  }

  getListaGed() {
    return this.http.get(
      `${this.apiUrl}/contribuinte/ged/listarTipoGeds`
    )
  }

  getCar(protocolo) {
    return this.http.get(
      `${this.apiUrl}/contribuinte/produtorRural/obterCar/${protocolo}`
    )
  }

  getListaGedIdentificador() {
    return this.http.get(
      `${this.apiUrl}/contribuinte/ged/listarTipoGedsIdentificador`
    )
  }

  getListaTipoImovel() {
    return this.http.get(
      `${this.apiUrl}/dominios/domTipoImovelRural/getAll`
    );
  }

  consultarCep(cep) {
    return this.http.get(
      `${this.apiUrl}/contribuinte/produtorRural/obterCep/${cep}`
    )
  }

  consultarCpfReceita(cpf) {
    return this.http.get(
      `${this.apiUrl}/contribuinte/cadastro/receitaFederal/${cpf}`
    )
  }

  consultarCrc(crc) {
    return this.http.get(
      `${this.apiUrl}/contribuinte/produtorRural/obterCrc/${crc}`
    )
  }

  cadastrarProdutor(obj) {
    return this.http.post(
      `${this.apiUrl}/contribuinte/produtorRural/`, obj
    )
  }

  alterarProdutor(obj) {
    return this.http.put(
      `${this.apiUrl}/contribuinte/produtorRural/`, obj
    )
  }

  getSolicitacoes(searchParams): Observable<any> {
    const params = this.setParams(searchParams);
    return this.http.get(
      `${this.apiUrl}/contribuinte/solicitacao/buscarPorContribuinte`, { params }
    );
  }

  getMovimentacoesPaginada(codigo, pagina, tamanhoPagina) {
    return this.http.get(
      `${this.apiUrl}/contribuinte/solicitacao/movimentacao?pagina=${pagina}&tamanhoPagina=${tamanhoPagina}&solicitacao=${codigo}`
    )
  }

  getMovimentacoes(codigo) {
    return this.http.get(
      `${this.apiUrl}/contribuinte/solicitacao/id/${codigo}`
    );
  }

  getSolicitacaoPorProtocolo(id) {
    return this.http.get(
      `${this.apiUrl}/contribuinte/solicitacao/id/${id}`
    )
  }

  getProdutorRural(codigo) {
    return this.http.get(
      `${this.apiUrl}/contribuinte/produtorRural/${codigo}/3`
    )
  }

  getEnderecoContribuinte(cpfCnpj: string) {
    return this.http.get(`${this.apiUrl}/contribuinte/listar/endereco/cpfCnpj/${cpfCnpj}`);
  }

  validarOcupacaoCar(obj) {
    return this.http.post(`${this.apiUrl}/contribuinte/produtorRural/validarUsoImovelSicar`, obj);
  }

  getEmailCadastro(codigoCadastro: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/contribuinte/cadastro/email/${codigoCadastro}`);
  }

  validarCepCategoriaOcupacao(cep: string) {
    return this.http.get(`${this.apiUrl}/contribuinte/produtorRural/validacao/cep/${cep}`);
  }

  validarEnderecoCategoriaOcupacao(obj) {
    return this.http.get(`${this.apiUrl}/contribuinte/produtorRural/validacao/endereco`, { params: obj });
  }
  
  setParams(searchParams) {
    let params = new HttpParams();
    if (!searchParams) {
      return params;
    }
    if (searchParams.key && searchParams.value) {
      return params.set(searchParams.key, searchParams.value);
    }
    for (const key of Object.keys(searchParams)) {
      params = params.set(key, searchParams[key]);
    }
    return params;
  }
  
}